import  request  from '../../Interceptor/request.js'

//根据手机号搜索对应住户
export function phoneHouse(data) {
    return request({
        url: '/member/queryHouseHold',
        method: 'post',
        data:data
    })
}

//绑定住户
export function bindHouse(data) {
    return request({
        url: '/member/bandHouseHold',
        method: 'post',
        data:data
    })
}

//解绑
export function unbindHouse() {
    return request({
        url: '/member/removeBandHouseHold',
        method: 'get'
    })
}